var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Producto")]),_c('th',[_vm._v("Deals")]),_c('th',[_vm._v("% Total deals")]),_c('th',[_vm._v("Inversión")]),_c('th',[_vm._v("Costo por deal")])])])
}]

export { render, staticRenderFns }